module.exports = __webpack_public_path__ + "img/team2_4.647a7310.jpg";